import { isFieldError } from "../helpers";

import Select from "../components/Select";
import Input from "../components/Input";
import Radios from "../components/Radios";
import Checkboxes from "../components/Checkboxes";

const InviteFields = ({
	names,
	handleUpdate,
	errors,
	details,
	handleCheckboxes,
}) => {
	return (
		<>
			<h4
				style={{
					marginTop: "0",
					lineHeight: "22px",
					marginBottom: "10px",
					fontSize: "1.1rem",
				}}
			>
				Guest Information
			</h4>

			<div className="form-group">
				<Select
					name="prefix"
					label="Prefix"
					reqd={true}
					value={names.prefix || ""}
					options={[
						{ id: "", name: "--" },
						{ id: "Mr.", name: "Mr." },
						{ id: "Mrs.", name: "Mrs." },
						{ id: "Ms.", name: "Ms." },
						{ id: "Dr.", name: "Dr." },
						{ id: "Other", name: "Other" },
					]}
					update={handleUpdate}
					error={isFieldError(errors, "prefix")}
				/>
				<div className="empty" />
			</div>

			<div className="form-group">
				<Input
					name="fname"
					label="First Name"
					reqd={true}
					value={names.fname || ""}
					autocomplete="given-name"
					update={handleUpdate}
					errors={errors}
				/>

				<Input
					name="lname"
					label="Last Name"
					reqd={true}
					value={names.lname || ""}
					autocomplete="family-name"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<div className="form-group ">
				<Input
					name="email"
					label="Email"
					reqd={true}
					value={names.email || ""}
					update={handleUpdate}
					errors={errors}
				/>

				<Input
					name="confirm"
					label="Confirm Email"
					reqd={true}
					value={names.confirm || ""}
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<h4
				style={{
					marginTop: "20px",
					lineHeight: "22px",
					marginBottom: "0",
					fontSize: "1.1rem",
				}}
			>
				Include the Following
			</h4>

			<div
				className="form-group three"
				style={{ marginTop: "0", marginBottom: "0" }}
			>
				<div className="form-group radios radios-alt">
					<Radios
						label="Monday, April 5, 2027"
						reqd={false}
						data={[]
							.concat(
								details.events1.map((item) => {
									return {
										name: "event1",
										val: item.name,
										label: item.val,
										disabled: item.disabled,
									};
								}),
							)
							.concat({
								name: "event1",
								val: "",
								label: "No Activity",
								disabled: false,
							})}
						value={""}
						click={handleUpdate}
					/>
				</div>

				<div className="form-group radios radios-alt">
					<Checkboxes
						label="Sunday, April 4, 2027"
						reqd={false}
						data={details.events2}
						values={[]}
						click={handleCheckboxes}
					/>
				</div>

				<div className="form-group radios radios-alt">
					<Checkboxes
						label="Gift Package"
						reqd={false}
						data={details.events3}
						values={[]}
						click={handleCheckboxes}
					/>
				</div>
			</div>
		</>
	);
};

export default InviteFields;
